import React from 'react';

import styles from './UndergroundIconWrapper.css';

interface IUndergroundIconWrapperProps {
  color?: string;
}

export const UndergroundIconWrapper: React.FC<IUndergroundIconWrapperProps> = ({ color, children }) => {
  return (
    <div className={styles['cont']} style={{ color }}>
      {children}
    </div>
  );
};
